import { pick } from 'lodash';

import type { SagaReturnType } from 'redux-saga/effects';
import { takeEvery, select, call, put } from 'redux-saga/effects';

import { touristsSelector } from 'src/store/tourists/selectors';
import { VALIDATE_TOURIST_FIELD } from '../../constants/tourists';

import { CONFIRM_CLIENT } from '../../constants/order';

import { getPackageId } from '../../selectors/package';
import { getOrderFlight } from '../../selectors/order';

import {
  addValidation,
  setValidationInProgress,
  clearValidations,
} from './slice';

import { api } from '../../../../../api';

const pickTourist = (tourist) =>
  pick(tourist || {}, [
    'gender',
    'name',
    'surname',
    'patronymic',
    'birthday',
    'passport_number',
    'passport_expires_on',
    'visa_service',
    'nationality_id',
  ]);

export function* validateTourist(tourist) {
  try {
    const packageId: SagaReturnType<typeof getPackageId> = yield select(
      getPackageId,
    );
    const flightPairId: SagaReturnType<typeof getOrderFlight> = yield select(
      getOrderFlight,
    );

    if (
      !(typeof flightPairId === 'string' || typeof flightPairId === 'undefined')
    ) {
      throw new Error(
        `validateTourist не корректный flightPairId: ${flightPairId}`,
      );
    }

    if (!(typeof packageId === 'number')) {
      throw new Error(`validateTourist не корректный packageId: ${packageId}`);
    }

    yield put(setValidationInProgress(true));

    const params = {
      package_id: packageId,
      flight_pair_id: flightPairId,
      tourist,
    };

    const response: SagaReturnType<typeof api.postTouristsValidate> =
      yield api.postTouristsValidate(params);

    const passportNumber = tourist.passport_number;

    const validation = {
      passportNumber,
      validation: response,
    };

    if (passportNumber) {
      yield put(addValidation(validation));
    }
  } finally {
    yield put(setValidationInProgress(false));
  }
}

function* handleClear() {
  yield put(clearValidations());
}

function* handleFieldValidate(action) {
  const { index, field } = action?.payload || {};

  if (field === 'passport_expires_on') {
    const tourists: SagaReturnType<typeof touristsSelector> = yield select(
      touristsSelector,
    );
    const tourist = pickTourist(tourists[index]);
    yield call(validateTourist, tourist);
  }
}

function* saga() {
  yield takeEvery(CONFIRM_CLIENT, handleClear);
  yield takeEvery(VALIDATE_TOURIST_FIELD, handleFieldValidate);
}

export default saga;
